export default [
  {
    id: 'a0bde3d3-a2c6-497e-8cb4-99e8b65bfd56', // id 全局唯一，终身制
    name: 'cloudRenderManagement',
    path: '/clond-render-management',
    meta: { title: '三维设置' },
    // layout: 'default',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: 'b50504e2-dd59-43e8-a9ea-68630c5e3bb9',
        name: 'labelManagement',
        path: 'label-management',
        component: () => {
          return import('./views/LabelManagement')
        },
        meta: {
          title: '标签管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '74562188-b4bd-4119-9ba9-2f0e1753d4f0',
        name: 'functionManagement',
        path: 'function-management',
        component: () => {
          return import('./views/FunctionManagement')
        },
        meta: {
          title: '功能管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '7380fbc8-af95-cd44-86aa-380ec9868db8',
        name: 'templateManagement',
        path: 'template-management',
        component: () => {
          return import('./views/TemplateManagement')
        },
        meta: {
          title: '三维方案管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            import: {
              id: 4,
              name: 'import',
              desc: '导入',
              access: true,
            },
            export: {
              id: 5,
              name: 'export',
              desc: '导出',
              group: 'read',
              access: true,
            },
          },
        },
      },
      {
        id: 'ddc45007-248f-4985-874f-56d30fb205c4',
        name: 'cockpitManagement',
        path: 'cockpit-management',
        component: () => {
          return import('./views/CockpitManagement')
        },
        meta: {
          title: '驾驶舱管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '8431928a-735f-2271-f765-97447074700a',
        name: 'alarmSourceConfig',
        path: 'alarm-source-config',
        component: () => {
          return import('./views/AlarmSourceConfig')
        },
        meta: {
          title: '报警来源配置',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            check: {
              id: 1,
              name: 'check',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
            setPushes: {
              id: 4,
              name: 'setPushes',
              desc: '推送设置',
              access: true,
            },
          },
        },
      },
      {
        id: 'a673f293-c4e6-5310-850c-34381da55662',
        name: 'alarmCenter',
        path: 'alarm-center',
        component: () => {
          return import('./views/AlarmCenter')
        },
        meta: {
          title: '三维报警中心',
          operations: {
            check: {
              id: 0,
              name: 'check',
              desc: '详情',
              access: true,
              group: 'read',
            },
          },
        },
      },
      {
        id: '6e76b135-93c1-8763-9b1c-c4ebc0bc8890',
        name: 'cloudNodeSettings',
        path: 'cloud-node-settings',
        component: () => {
          return import('./views/CloudNodeSettings')
        },
        meta: {
          title: '云渲染节点管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            read: {
              id: 1,
              name: 'read',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '修改',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
